export const serverDetailData = {
  models: [
    {
      name: 'CloudUSB-K45',
      subtitle: '45端口 · 机柜型 · 第二代',
      image:
        'https://storage.helloreaddy.io/project_files/d3244921-9c44-4475-bb7d-d9f1f2d3d4fd/9ae3f497-4e56-4104-ac4c-14101b8e2877_compressed_UCloudUSB-K45.webp',
      features: [
        '45个U盾接口+内置45个机械臂，基于专利技术模块化架构',
        '工业级无风扇高性能服务器，7×24小时超静音稳定运行',
        '独立端口15KV防静电+10A防浪涌+双向保护+硬件强制复位',
      ],
      intro:
        '第二代45端口机柜型U盾服务器，基于专利技术模块化架构，内置45个机械臂自动按压确认键，7×24小时超静音稳定运行，支持私有化部署与RPA自动化对接。',
      video:
        'https://storage.helloreaddy.io/project_files/d3244921-9c44-4475-bb7d-d9f1f2d3d4fd/eacdd5d9-560b-41fc-8376-71202347d6fc_UCloudUSB-K45.mp4',
      specs: {
        coreFeatures: [
          '支持局域网远程共享使用USB设备的智能USB服务器',
          '兼容各种网银U盾、社保公积金CA证书、报税盘、招投标U盾、加密狗等通用USB设备',
          '基于专利技术的模块化架构：每台设备具备45个U盾接口且内置45个机械臂',
          '工业级低功耗无风扇高性能服务器、超静音设计，7×24小时连续稳定运行',
          '每个端口可独立控制通电、断电、远程映射使用权以及自动控制机械臂按压U盾确认键；且具有硬件强制复位按钮',
          '每个端口具备独立的15千伏防静电和10A防浪涌电流保护能力、长期持续短路保护能力',
          '双向保护，可确保有故障的U盾不会损坏U盾管理设备、U盾管理设备故障不会损坏U盾',
          '支持独立私有化部署权限管控平台和内置权限管控平台',
          '提供RPA接口软件和人工连接U盾的客户端软件',
        ],
        certifications: [
          '国家应用软件产品质量监督检验中心 等保三级 安全测评认证',
          '中国国家强制性产品CCC认证',
          'GB/T 2423.2-2008 45℃高温连续稳定性测试',
          'GB/T 9254.1-2021 电磁兼容性测试',
          'GB/T 4943.1-2022 电气安全测评',
          '第三方漏洞扫描',
        ],
        softwareEnv: [
          '客户端支持Windows全系操作系统',
          '客户端支持网银系统支持的国产操作系统',
          '权限管控平台兼容所有Linux架构的国产和开源操作系统',
        ],
        ioInterface: ['双千兆以太网卡', '12V电源输入接口'],
        workEnv: [
          '输入电压范围：110V~250V',
          '待机功耗：小于15W',
          '峰值功耗：小于55W',
          '存储温度范围：-20~85°C',
        ],
        dimensions: [
          '19英寸服务器宽度设计5U高，支持机柜安装使用',
          '长度：480毫米 × 高度223毫米 × 深度225毫米',
        ],
      },
    },
    {
      name: 'CloudUSB-K24',
      subtitle: '24端口 · 机柜型 · 第二代',
      image: 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/93c529138bb3cdbcdf1ff9b357c5211f.png',
      features: [
        '24个U盾接口+内置24个机械臂，基于专利技术模块化架构',
        '工业级无风扇高性能服务器，7×24小时超静音稳定运行',
        '独立端口15KV防静电+10A防浪涌+双向保护+硬件强制复位',
      ],
      intro:
        '第二代24端口机柜型U盾服务器，基于专利技术模块化架构，内置24个机械臂自动按压确认键，7×24小时超静音稳定运行，支持私有化部署与RPA自动化对接。',
      video:
        'https://storage.helloreaddy.io/project_files/d3244921-9c44-4475-bb7d-d9f1f2d3d4fd/711aae83-ac1f-48c2-b889-a9f571425e9f_UCloudUSB-K24.mp4',
      specs: {
        coreFeatures: [
          '支持局域网远程共享使用USB设备的智能USB服务器',
          '兼容各种网银U盾、社保公积金CA证书、报税盘、招投标U盾、加密狗等通用USB设备',
          '基于专利技术的模块化架构：每台设备具备24个U盾接口且内置24个机械臂',
          '工业级低功耗无风扇高性能服务器、超静音设计，7×24小时连续稳定运行',
          '每个端口可独立控制通电、断电、远程映射使用权以及自动控制机械臂按压U盾确认键；且具有硬件强制复位按钮',
          '每个端口具备独立的15千伏防静电和10A防浪涌电流保护能力、长期持续短路保护能力',
          '双向保护，可确保有故障的U盾不会损坏U盾管理设备、U盾管理设备故障不会损坏U盾',
          '支持独立私有化部署权限管控平台和内置权限管控平台',
          '提供RPA接口软件和人工连接U盾的客户端软件',
        ],
        certifications: [
          '国家应用软件产品质量监督检验中心 等保三级 安全测评认证',
          '中国国家强制性产品CCC认证',
          'GB/T 2423.2-2008 45℃高温连续稳定性测试',
          'GB/T 9254.1-2021 电磁兼容性测试',
          'GB/T 4943.1-2022 电气安全测评',
          '第三方漏洞扫描',
        ],
        softwareEnv: [
          '客户端支持Windows全系操作系统',
          '客户端支持网银系统支持的国产操作系统',
          '权限管控平台兼容所有Linux架构的国产和开源操作系统',
        ],
        ioInterface: ['双千兆以太网卡', '12V电源输入接口'],
        workEnv: [
          '输入电压范围：110V~250V',
          '待机功耗：小于15W',
          '峰值功耗：小于55W',
          '存储温度范围：-20~85°C',
        ],
        dimensions: [
          '19英寸服务器宽度设计3U高，支持机柜安装使用',
          '长度：480毫米 × 高度134毫米 × 深度225毫米',
        ],
      },
    },
    {
      name: 'CloudUSB-MK45',
      subtitle: '45端口 · 保险柜型 · 第二代',
      image:
        'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/29f9ea5d5b59c0e11b6c6f935a302ce7.png',
      features: [
        '45个U盾接口+内置45个机械臂，基于专利技术模块化架构',
        '自带密码锁保险柜机柜，支持桌面安装使用',
        '独立端口15KV防静电+10A防浪涌+双向保护+硬件强制复位',
      ],
      intro:
        '自带密码锁机柜的桌面型网银U盾保险柜，内置专业版PK45智能U盾服务器（45端口），支持机械锁/密码锁/指纹密码锁三种配置可选，7×24小时超静音稳定运行，支持私有化部署与RPA自动化对接。',
      video:
        'https://storage.helloreaddy.io/project_files/d3244921-9c44-4475-bb7d-d9f1f2d3d4fd/f604eb7d-47c4-441b-a00b-ab4b76bbb49c_UCloudUSB-MK45.mp4',
      specs: {
        coreFeatures: [
          '自带密码锁机柜的网银U盾保险柜',
          '内置专业版CloudUSB-PK45智能U盾服务器',
          '兼容各种网银U盾、社保公积金CA证书、报税盘、招投标U盾、加密狗等通用USB设备',
          '基于专利技术的模块化架构：每台设备具备45个U盾接口且内置45个机械臂',
          '工业级低功耗无风扇高性能服务器、超静音设计，7×24小时连续稳定运行',
          '每个端口可独立控制通电、断电、远程映射使用权以及自动控制机械臂按压U盾确认键；且具有硬件强制复位按钮',
          '每个端口具备独立的15千伏防静电和10A防浪涌电流保护能力、长期持续短路保护能力',
          '双向保护，可确保有故障的U盾不会损坏U盾管理设备、U盾管理设备故障不会损坏U盾',
          '支持独立私有化部署权限管控平台和内置权限管控平台',
          '提供RPA接口软件和人工连接U盾的客户端软件',
        ],
        certifications: [
          '国家应用软件产品质量监督检验中心 等保三级 安全测评认证',
          'GB/T 2423.2-2008 45℃高温连续稳定性测试',
          'GB/T 9254.1-2021 电磁兼容性测试',
          'GB/T 4943.1-2022 电气安全测评',
          '第三方漏洞扫描',
        ],
        softwareEnv: [
          '客户端支持Windows全系操作系统',
          '客户端支持网银系统支持的国产操作系统',
          '权限管控平台兼容所有Linux架构的国产和开源操作系统',
        ],
        ioInterface: ['双千兆以太网卡', '12V电源输入接口'],
        workEnv: [
          '输入电压范围：110V~250V',
          '待机功耗：小于15W',
          '峰值功耗：小于55W',
          '存储温度范围：-20~85°C',
        ],
        dimensions: [
          '自带密码锁机柜，支持桌面安装使用',
          '外形尺寸：525毫米宽*320毫米深*275毫米高',
        ],
      },
    },
    {
      name: 'CloudUSB-MK24',
      subtitle: '24端口 · 保险柜型 · 第二代',
      image:
        'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/fd2f6e259c791ab2b3e7a0056160f172.png',
      features: [
        '24个U盾接口+内置24个机械臂，基于专利技术模块化架构',
        '自带密码锁保险柜机柜，支持桌面安装使用',
        '独立端口15KV防静电+10A防浪涌+双向保护+硬件强制复位',
      ],
      intro:
        '自带密码锁机柜的桌面型网银U盾保险柜，内置专业版PK24智能U盾服务器（24端口），支持机械锁/密码锁/指纹密码锁三种配置可选，7×24小时超静音稳定运行，支持私有化部署与RPA自动化对接。',
      video:
        'https://storage.helloreaddy.io/project_files/d3244921-9c44-4475-bb7d-d9f1f2d3d4fd/98fe875a-bf60-481d-ab4a-173282799088_UCloudUSB-MK24.mp4',
      specs: {
        coreFeatures: [
          '自带密码锁机柜的网银U盾保险柜',
          '内置专业版CloudUSB-PK24智能U盾服务器',
          '兼容各种网银U盾、社保公积金CA证书、报税盘、招投标U盾、加密狗等通用USB设备',
          '基于专利技术的模块化架构：每台设备具备24个U盾接口且内置24个机械臂',
          '工业级低功耗无风扇高性能服务器、超静音设计，7×24小时连续稳定运行',
          '每个端口可独立控制通电、断电、远程映射使用权以及自动控制机械臂按压U盾确认键；且具有硬件强制复位按钮',
          '每个端口具备独立的15千伏防静电和10A防浪涌电流保护能力、长期持续短路保护能力',
          '双向保护，可确保有故障的U盾不会损坏U盾管理设备、U盾管理设备故障不会损坏U盾',
          '支持独立私有化部署权限管控平台和内置权限管控平台',
          '提供RPA接口软件和人工连接U盾的客户端软件',
        ],
        certifications: [
          '国家应用软件产品质量监督检验中心 等保三级 安全测评认证',
          'GB/T 2423.2-2008 45℃高温连续稳定性测试',
          'GB/T 9254.1-2021 电磁兼容性测试',
          'GB/T 4943.1-2022 电气安全测评',
          '第三方漏洞扫描',
        ],
        softwareEnv: [
          '客户端支持Windows全系操作系统',
          '客户端支持网银系统支持的国产操作系统',
          '权限管控平台兼容所有Linux架构的国产和开源操作系统',
        ],
        ioInterface: ['双千兆以太网卡', '12V电源输入接口'],
        workEnv: [
          '输入电压范围：110V~250V',
          '待机功耗：小于15W',
          '峰值功耗：小于55W',
          '存储温度范围：-20~85°C',
        ],
        dimensions: [
          '自带密码锁机柜，支持桌面安装使用',
          '外形尺寸：525毫米宽×320毫米深×185毫米高',
        ],
      },
    },
    {
      name: 'CloudUSB-P40',
      subtitle: '40端口 · 机柜型 · 第一代',
      image:
        'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/a897735d4108cf32f340503e48da8c5c.png',
      features: [
        '40个U盾端口，基于第一代模块化架构',
        '工业级无风扇高性能服务器，7×24小时超静音稳定运行',
        '独立端口15KV防静电+10A防浪涌+双向保护',
      ],
      intro:
        '第一代40端口机柜型U盾服务器，基于模块化架构，7×24小时超静音稳定运行，支持私有化部署与RPA自动化对接。',
      specs: {
        coreFeatures: [
          '支持局域网远程共享使用USB设备的智能USB服务器',
          '兼容各种第一代网银U盾、社保公积金CA证书、报税盘、招投标U盾、加密狗等通用USB设备',
          '40个U盾端口，基于第一代模块化架构',
          '工业级低功耗无风扇高性能服务器、超静音设计，7×24小时连续稳定运行',
          '每个端口可独立控制通电、断电、远程映射使用权',
          '每个端口具备独立的15千伏防静电和10A防浪涌电流保护能力、长期持续短路保护能力',
          '双向保护，可确保有故障的U盾不会损坏U盾管理设备、U盾管理设备故障不会损坏U盾',
          '支持独立私有化部署权限管控平台和内置权限管控平台',
          '提供RPA接口软件和人工连接U盾的客户端软件',
        ],
        certifications: [
          '国家应用软件产品质量监督检验中心 等保三级 安全测评认证',
          '中国国家强制性产品CCC认证',
          'GB/T 2423.2-2008 45℃高温连续稳定性测试',
          'GB/T 9254.1-2021 电磁兼容性测试',
          'GB/T 4943.1-2022 电气安全测评',
          '第三方漏洞扫描',
        ],
        softwareEnv: [
          '客户端支持Windows全系操作系统',
          '客户端支持网银系统支持的国产操作系统',
          '权限管控平台兼容所有Linux架构的国产和开源操作系统',
        ],
        ioInterface: ['双千兆以太网卡', '12V电源输入接口'],
        workEnv: [
          '输入电压范围：110V~250V',
          '待机功耗：小于15W',
          '峰值功耗：小于55W',
          '存储温度范围：-20~85°C',
          '工作温度：0~45°C',
        ],
        dimensions: [
          '19英寸标准服务器架构，支持机柜安装使用',
          '外形尺寸：480毫米宽*320毫米深*275毫米高',
        ],
      },
    },
    {
      name: 'CloudUSB-YZ40',
      subtitle: '40端口 · 机柜型 · 银企直连专用',
      image:
        'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/2b6467609b9a3fb006b193303d1a391c.png',
      features: [
        '40个U盾端口，针对银企直连场景特殊优化',
        '支持U盾断网续连与虚拟机漂移',
        '工业级无风扇高性能服务器，7×24小时稳定运行',
      ],
      intro:
        '银企直连专用40端口U盾服务器，针对银企直连场景特殊优化，支持U盾断网续连、超融合与虚拟机漂移，7×24小时稳定运行。',
      specs: {
        coreFeatures: [
          '40个U盾管理端口，针对银企直连场景特殊优化，支持U盾断网续连',
          '支持各种超融合、虚拟化平台、虚拟机漂移等场景',
          '兼容各种银企直连U盾、社保公积金CA证书、报税盘、招投标U盾、加密狗等通用USB设备',
          '工业级低功耗无风扇高性能服务器、超静音设计，7×24小时连续稳定运行',
          '每个端口可独立控制通电、断电、远程映射使用权',
          '每个端口具备独立的15千伏防静电和10A防浪涌电流保护能力、长期持续短路保护能力',
          '双向保护，可确保有故障的U盾不会损坏U盾管理设备、U盾管理设备故障不会损坏U盾',
          '支持独立私有化部署权限管控平台和内置权限管控平台',
          '提供RPA接口软件和人工连接U盾的客户端软件',
        ],
        certifications: [
          '国家应用软件产品质量监督检验中心 等保三级 安全测评认证',
          'GB/T 2423.2-2008 45℃高温连续稳定性测试',
          'GB/T 9254.1-2021 电磁兼容性测试',
          'GB/T 4943.1-2022 电气安全测评',
          '第三方漏洞扫描',
        ],
        softwareEnv: [
          '客户端支持Windows全系操作系统',
          '客户端支持网银系统支持的国产操作系统',
          '权限管控平台兼容所有Linux架构的国产和开源操作系统',
        ],
        ioInterface: ['双千兆以太网卡', '12V电源输入接口'],
        workEnv: [
          '输入电压范围：110V~250V',
          '待机功耗：小于15W',
          '峰值功耗：小于55W',
          '存储温度范围：-20~85°C',
          '工作温度：0~45°C',
        ],
        dimensions: [
          '19英寸标准服务器架构，支持机柜安装使用',
          '外形尺寸：480毫米宽*320毫米深*275毫米高',
        ],
      },
    },
    {
      name: 'CloudUSB-CX',
      subtitle: '指纹密码锁机柜',
      image:
        'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/b22b0724112df4b2586d05e24f5b84a9.png',
      features: [
        '高度按需定制，单侧最多容纳400个第二代U盾',
        '可选指纹/密码/指纹+密码多种开锁方式',
        '柜顶配风扇有效降温，内置可视通风窗',
      ],
      intro:
        '专为U盾服务器设计的指纹密码锁机柜，高度可按需定制，单侧最多可容纳400个第二代U盾或800个第一代U盾，支持指纹、密码、指纹+密码多种开锁方式，配备柜顶风扇与可视通风窗。',
    },
  ],
  certifications: [
    {
      name: 'CCC质量认证',
      icon: 'ri-award-line',
      desc: '率先通过中国质量认证中心CCC认证，支持CQC官方查验',
    },
    {
      name: '等保三级测评',
      icon: 'ri-shield-check-line',
      desc: '率先通过等保三级机房接入标准安全测评',
    },
    {
      name: '发明专利技术',
      icon: 'ri-lightbulb-line',
      desc: '基于发明专利的集成式模块化架构，装卸U盾更方便',
    },
    {
      name: '双向安全保护',
      icon: 'ri-flashlight-line',
      desc: '15KV防静电、过压过流与持续短路保护',
    },
  ],
  scenarios: [
    { name: '集团财务共享中心', icon: 'ri-building-4-line' },
    { name: '业务管理中心', icon: 'ri-funds-line' },
    { name: '银企直连机房', icon: 'ri-server-line' },
    { name: '央企国企内网', icon: 'ri-bank-line' },
  ],
};